import {
  IGeometryModel,
  MarkerModelBase,
} from '@types-custom/models/business/marker.model';
import { Icon } from '@types-custom/models/ui/icon-model';

export interface IPropsSkateboardModel {
  id: string;
  icon?: Icon;
  address: string;
  name: string;
  markerPopupText: string;
}

export class SkateboardModel extends MarkerModelBase {
  static className = 'SkateboardModel';

  classProperties: IPropsSkateboardModel;

  constructor(props: IPropsSkateboardModel, geometry: IGeometryModel) {
    super(geometry, SkateboardModel.className);
    this.classProperties = props;
  }
}
